import ArtisanTable from "src/components/artisan/ArtisanTable";
import ArtisanStaleTable from "src/components/artisan/ArtisanStaleTable";
import { auth } from "src/store/Auth";
import { DashboardLayout } from "src/components/dashboard";
import { Input } from "src/components/inputs";
import searchIcon from "src/assets/images/input/searchIcon.svg";
import { useEffect, useState, useRef } from "react";
import { useLoading, useExportData } from "src/hooks";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Loader } from "src/components/common";
import { toast, ToastContainer } from "react-toastify";
import { PaginationProps } from "src/components/ui/Pagination";
import {
  Button,
  ButtonClass,
  ConfirmationModal,
  Flex,
} from "src/components/ui";
import { theme } from "src/styles/Theme";
import { SendNotificationModal } from "src/components/users";
import AppModal from "src/components/ui/widget/Modal/Modal";
import ModalContent from "src/components/common/ModalContent";
import {
  useGetAllArtisansQuery,
  useGetAllStaleArtisansQuery,
  useLazyDumpArtisansDataQuery,
  useBringVendorsOnlineMutation,
} from "src/store/services/artisanApi";

interface Props {
  handleChangeSearch: (e: any) => void;
  handleStale: (e: any) => void;
  handleActive: (e: any) => void;
  handleOpen: (e: any) => void;
  handleExport: () => void;
  staleTableBtn: boolean;
  setLastLoginRange: React.Dispatch<React.SetStateAction<string>>;
}

export default function Artisan() {
  const [searchField, setSearchField] = useState("");
  const [filterDrop, setFilterDrop] = useState("");
  const [open, setOpen] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [showStaleAccount, setShowStaleAccount] = useState(false);
  const [staleTableBtn, setStaleTableBtn] = useState(true);
  const [lastLoginRange, setLastLoginRange] = useState('');

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [Ppage, setPage] = useState(1);
  const [Spage, setSPage] = useState(1);

  const [paginationData, setPaginationData] = useState<PaginationProps>({
    page: 0,
    pageSize: 0,
    total: 0,
    totalPages: 0,
  });

  const [sPaginationData, setSPaginationData] = useState<PaginationProps>({
    page: 0,
    pageSize: 0,
    total: 0,
    totalPages: 0,
  });

  const { data: artisans, isLoading: isLoadingArtisans } =
    useGetAllArtisansQuery({
      page: Ppage,
      limit: 10,
      vendor_type: "individual",
      search: searchField,
      status: filterDrop,
      lastLoginRange: lastLoginRange,
    });
  const { data: staleArtisans, isLoading: isLoadingStaleArtisans } =
    useGetAllStaleArtisansQuery({ page: Spage, limit: 10, lastLoginRange: lastLoginRange });
  const [triggerDumpArtisansData] = useLazyDumpArtisansDataQuery();

  useEffect(() => {
    document.title = "Vendor's Page";
  }, []);

  const handleStale = () => {
    setShowStaleAccount(true);
    setStaleTableBtn(false);
  };
  const handleActive = () => {
    setShowStaleAccount(false);
    setStaleTableBtn(true);
  };
  useEffect(() => {
    if (artisans?.payload?.pagination) {
      setPaginationData(artisans.payload.pagination);
    }
  }, [artisans]);

  useEffect(() => {
    if (staleArtisans?.payload?.pagination) {
      setSPaginationData(staleArtisans.payload.pagination);
    }
  }, [staleArtisans]);
  const filteredData = (artisans?.payload?.data ?? []).filter((data: any) => {
    return (
      data?.first_name?.toLowerCase().includes(searchField.toLowerCase()) ||
      data?.last_name?.toLowerCase().includes(searchField.toLowerCase()) ||
      data?.email?.toLowerCase().includes(searchField.toLowerCase()) ||
      data?.occupation?.toLowerCase().includes(searchField.toLowerCase()) ||
      data?.gender?.toLowerCase().includes(searchField.toLowerCase()) ||
      data?.phone?.toLowerCase().includes(searchField.toLowerCase()) ||
      data?.country_name?.toLowerCase().includes(searchField.toLowerCase())
    );
  });

  const filteredStaleData = (staleArtisans?.payload?.data ?? []).filter(
    (data: any) => {
      return (
        data?.first_name?.toLowerCase().includes(searchField.toLowerCase()) ||
        data?.last_name?.toLowerCase().includes(searchField.toLowerCase()) ||
        data?.email?.toLowerCase().includes(searchField.toLowerCase()) ||
        data?.occupation?.toLowerCase().includes(searchField.toLowerCase()) ||
        data?.gender?.toLowerCase().includes(searchField.toLowerCase()) ||
        data?.phone?.toLowerCase().includes(searchField.toLowerCase()) ||
        data?.country_name?.toLowerCase().includes(searchField.toLowerCase())
      );
    },
  );

  const handleChangeSearch = (e: any) => {
    setSearchField(e.target.value);
  };

  //Exporting data to csv format
  const artisansHeaders = [
    "First name",
    "Last name",
    "Email",
    "Status",
    "Suspended",
    "Gender",
    "Occupation",
    "Phone",
  ];

  

  const {
    loading: exportingData,
    startLoading: startExportingData,
    stopLoading: stopExportingData,
  } = useLoading(false);

  const dumpArtisanData = async () => {
    startExportingData();
    try {
      const res: any = await triggerDumpArtisansData().unwrap();
      setShowExportModal(false);
      toast.success(res?.message);
      const url = res?.payload?.data?.fileUrl;
      if (url) window.location.href = url;
    } catch (err: any) {
      toast.error(err?.data?.error?.message || "Export failed");
    } finally {
      stopExportingData();
    }
  };

  return (
    <DashboardLayout
      pageTitle="Vendor"
      rhsHeading={
        <RhsHeading
          handleChangeSearch={handleChangeSearch}
          handleOpen={handleOpen}
          handleStale={handleStale}
          handleActive={handleActive}
          staleTableBtn={staleTableBtn}
          handleExport={() => setShowExportModal(!showExportModal)}
          setLastLoginRange={setLastLoginRange}
        />
      }
    >
      <SendNotificationModal
        open={open}
        userId={[""]}
        handleClose={handleClose}
        artisan={"artisan"}
      />
      <ToastContainer />
      {(isLoadingArtisans && !showStaleAccount) ||
      (isLoadingStaleArtisans && showStaleAccount) ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "100px",
          }}
        >
          <Loader>loading...</Loader>{" "}
        </div>
      ) : showStaleAccount ? (
        <ArtisanStaleTable
          filteredRow={filteredStaleData}
          Spage={Spage}
          setSPage={setSPage}
          paginationData={sPaginationData}
        />
      ) : filteredData.length > 0 ? (
        <ArtisanTable
          filteredRow={filteredData}
          Ppage={Ppage}
          setPage={setPage}
          paginationData={paginationData}
          setFilterDrop={setFilterDrop}
        />
      ) : (
        <p className="table-entry-status">No Vendor Found</p>
      )}
      <AppModal
        open={showExportModal}
        onClose={() => setShowExportModal(false)}
        content={
          <ModalContent
            content1="Export Artisans Data"
            content2="Are you sure you want to export artisans data?"
            btnAction={dumpArtisanData}
            linkContent={"Yes, Please"}
            onClick={() => setShowExportModal(false)}
            loading={exportingData}
          />
        }
      />
    </DashboardLayout>
  );
}

export const RhsHeading: React.FC<Props> = ({
  handleChangeSearch,
  handleOpen,
  handleExport,
  handleStale,
  handleActive,
  staleTableBtn,
  setLastLoginRange,
}) => {
  const [isOccupManager, setIsOccupManager] = useState(false);
  const { authUser } = auth.use();
  const [isModalOnlineOpen, setIsModalOnlineOpen] = useState(false);
  const [isModalOfflineOpen, setIsModalOfflineOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const {
    loading: activatingVendors,
    startLoading: startActivating,
    stopLoading: stopActivating,
  } = useLoading(false);

  const {
    loading: deactivatingVendors,
    startLoading: startDeactivating,
    stopLoading: stopDeactivating,
  } = useLoading(false);

  useEffect(() => {
    if (authUser?.role?.includes("occupationalManager")) {
      setIsOccupManager(true);
    }
  }, [authUser]);

  // Function to bring vendors online
  const [bringVendorsOnlineMutation] = useBringVendorsOnlineMutation();
  const bringVendorsOnline = async () => {
    startActivating();
    try {
      const res: any = await bringVendorsOnlineMutation({
        status: "online",
      }).unwrap();
      toast.success(res?.message || "Vendors set online");
    } catch (error: any) {
      toast.error(error?.data?.error?.message || "Failed to set online");
    } finally {
      setIsModalOnlineOpen(false);
      stopActivating();
    }
  };

  // Function to set vendors offline
  const setVendorsOffline = async () => {
    startDeactivating();
    try {
      const res: any = await bringVendorsOnlineMutation({
        status: "offline",
      }).unwrap();
      toast.success(res?.message || "Vendors set offline");
    } catch (error: any) {
      toast.error(error?.data?.error?.message || "Failed to set offline");
    } finally {
      setIsModalOfflineOpen(false);
      stopDeactivating();
    }
  };

  const timePeriods = [
    "All Vendors",
    "Last 24 Hours",
    "Last 7 Days",
    "Last 14 Days",
    "Last 30 Days",
    "Last 90 Days",
    "Last 180 Days",
    "Last 365 Days",
  ];

  const [timePeriod, setTimePeriod] = useState("All Vendors");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);


  

  return (
    <Flex wrap="wrap">
      {/* Confirmation modal for bringing vendors online */}
      <ConfirmationModal
        approve={bringVendorsOnline}
        handleClose={() => setIsModalOnlineOpen(false)}
        loading={activatingVendors}
        message="Change all vendors to online status?"
        open={isModalOnlineOpen}
      />

      {/* Confirmation modal for setting vendors offline */}
      <ConfirmationModal
        approve={setVendorsOffline}
        handleClose={() => setIsModalOfflineOpen(false)}
        loading={deactivatingVendors}
        message="Change all vendors to offline status?"
        open={isModalOfflineOpen}
      />

      {/* Export button */}
      <Button
        onClick={handleExport}
        classes={[ButtonClass.SOLID, ButtonClass.WITH_ICON]}
        style={{
          backgroundColor: theme.colors.purple,
          height: "48px",
          minWidth: "145px",
        }}
        className={`${isOccupManager ? "!hidden" : ""}`}
      >
        <span>Export</span>
      </Button>

      {/* Notify all artisans */}
      <Button
        onClick={handleOpen}
        classes={[ButtonClass.SOLID, ButtonClass.WITH_ICON]}
        style={{
          backgroundColor: theme.colors.purple,
          height: "48px",
          width: "max-content",
        }}
        className={`${isOccupManager ? "!hidden" : ""}`}
      >
        <span>Notify all artisans</span>
      </Button>

      {/* Set vendors online */}
      <Button
        onClick={() => setIsModalOnlineOpen(true)}
        classes={[ButtonClass.SOLID, ButtonClass.WITH_ICON]}
        style={{
          backgroundColor: theme.colors.purple,
          height: "48px",
          width: "max-content",
        }}
        className={`${isOccupManager ? "!hidden" : ""}`}
      >
        <span>Set all vendors online</span>
      </Button>

      {/* Set vendors offline */}
      <Button
        onClick={() => setIsModalOfflineOpen(true)}
        classes={[ButtonClass.SOLID, ButtonClass.WITH_ICON]}
        style={{
          backgroundColor: "#eb5656",
          height: "48px",
          width: "max-content",
        }}
        className={`${isOccupManager ? "!hidden" : ""}`}
      >
        <span>Set all vendors offline</span>
      </Button>

      {/* Search input */}
      <Input
        icon={<img src={searchIcon} alt="searchIcon" />}
        type="search"
        placeholder="Search"
        handleChange={handleChangeSearch}
      />

      <Button
        onClick={handleActive}
        classes={[ButtonClass.SOLID, ButtonClass.WITH_ICON]}
        style={{
          backgroundColor: "#eb5656",
          height: "48px",
          width: "max-content",
        }}
        className={`${isOccupManager ? "!hidden" : ""}`}
        disabled={staleTableBtn}
      >
        <span>Active Accounts</span>
      </Button>
      <Button
        onClick={handleStale}
        classes={[ButtonClass.SOLID, ButtonClass.WITH_ICON]}
        style={{
          backgroundColor: "#210639",
          height: "48px",
          width: "max-content",
        }}
        className={`${isOccupManager ? "!hidden" : ""}`}
        disabled={!staleTableBtn}
      >
        <span>Stale Accounts</span>
      </Button>

      <div className="relative" ref={dropdownRef}>
        <button
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors flex items-center gap-2"
        >
          {timePeriod}
          <KeyboardArrowDownIcon fontSize="small" />
        </button>
        {isDropdownOpen && (
          <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-10">
            {timePeriods.map((period) => (
              <button
                key={period}
                onClick={() => {
                  setTimePeriod(period);
                  setIsDropdownOpen(false);
                  if (period == 'Last 24 Hours'){
                    setLastLoginRange("24h")
                  }
                  else if (period == 'Last 7 Days'){
                    setLastLoginRange("7d")
                  }
                  else if (period == 'All Vendors'){
                    setLastLoginRange("")
                  }
                  else if (period == 'Last 14 Days'){
                    setLastLoginRange("14d")
                  }
                  else if (period == 'Last 30 Days'){
                    setLastLoginRange("30d")
                  }
                  else if (period == 'Last 90 Days'){
                    setLastLoginRange("90d")
                  }
                  else if (period == 'Last 180 Days'){
                    setLastLoginRange("90d")
                  }
                  else if (period == 'Last 365 Days'){
                    setLastLoginRange("1y")
                  }

                  
                }}
                className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-50 first:rounded-t-lg last:rounded-b-lg ${
                  timePeriod === period
                    ? "bg-purple-50 text-purple-600"
                    : "text-gray-700"
                }`}
              >
                {period}
              </button>
            ))}
          </div>
        )}
      </div>
    </Flex>
  );
};
